import script from "./JournalCard.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalCard.vue?vue&type=script&setup=true&lang=js"

import "./JournalCard.vue?vue&type=style&index=0&id=63555fef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63555fef"]])

export default __exports__